<template>
  <div>
<!--    <v-btn class="ml-1"-->
<!--        dark-->
<!--        color="#59C3C3"-->
<!--        x-small-->
<!--        fab-->
<!--        @click="action(data, 'edit')"-->
<!--        outlined> <v-icon dark>mdi-pencil</v-icon></v-btn>-->

  <v-btn class="ml-1"
      dark
      color="primary"
      x-small
      fab
      @click="action(data, 'information')"
      outlined> <v-icon dark>mdi-information</v-icon></v-btn>


  </div>
</template>

<script>

    export default {
      props: {
        data:{},

        action:{
          type:Function
        },meta:{
          type:Object
        }
      },


    }
</script>
